<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:100px;">
            <priceworkflow-signoff-chart
                :stepsData="stepsData"
                :submission="submission"
            ></priceworkflow-signoff-chart>
            <br><br>
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="loading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else style="display:flex;">
                <section style="width:30%; padding-right:24px;">
                    <img :src="imgSource" style="width:100%;height:auto;" />
                </section>
                <section style="width:70%; max-width: 600px;">
                    <h3 v-html="brand"></h3>
                    <p>{{ shortDesc }}</p>
                    <span style="color:#cd1b00;font-weight:bold;">{{ submission.prod_key }}</span>
                    <p><strong>COMPANY: </strong>{{ submission.company }}</p>
                    <p>
                        <strong>ACTIVITY: </strong>
                        <img v-if="submission.urgent" src="/images/price-workflow/icon-circle-important.png" style="position:relative; height:1rem; width:auto;">
                        {{ activity }}
                    </p>
                    <p><strong>RATIONALE: </strong>{{ submission.rationale }}</p>
                    <p v-if="submission.eff_date != null && submission.expiration_date != ''">
                        <strong>EFFECTIVE DATE: </strong>{{ submission.eff_date }}
                    </p>
                    <p v-if="submission.expiration_date != null && submission.expiratione_date != ''">
                        <strong>EXPIRATION DATE: </strong>{{ submission.expiration_date }}
                    </p>
                    <p v-if="coo == 'China'" style="color:#cd1b00;">
                        <strong>COUNTRY OF ORIGIN: </strong>{{ coo }}
                    </p>
                    <p v-else>
                        <strong>COUNTRY OF ORIGIN: </strong>{{ coo }}
                    </p>
                    <br>
                    <p v-if="submission.rationale == 'Internal Product Conversion'">
                        <strong>PRODUCT CONVERSION</strong><br>
                        &bull;Replacement Style: {{ submission.prod_conv_style }}<br>
                        &bull;Expiration: {{ submission.prod_conv_exp }}<br><br>
                    </p>
                    <p><strong>PRICING </strong>({{ submission.price_level }})</p>
                    <p>&bull;Curr: ${{ custPrice }}/{{ uom }} ({{ listVar }}%)</p>
                    <p>&bull;Sugg: ${{ submission.sug_price }}/{{ uom }} ({{ submission.sug_var }}%)</p>
                    <br>
                    <p><strong>12M SALES</strong></p>
                    <p>&bull;Curr: ${{ submission.sales_12m }}</p>
                    <p>&bull;Sugg: {{ submission.proj_sales }}</p>
                    <br>
                    <div v-if="submission.ord_num != null && submission.ord_num != ''">
                        <p>
                            <strong>ORDER NUMBER(S)</strong>
                            <p v-for="order in orderNumbers">&bull;{{ order }}</p>
                        </p>
                        <br>
                    </div>
                    <p><strong>SKUs</strong></p>
                    <p v-for="sku in submission.price_sku">&bull;{{ sku.sku }} ({{ sku.prod_id }})</p>
                    
                    <priceworkflow-signoff-block v-if="(submissionStatus == 'p' && isApprover) || (submissionStatus == 'a' && isErpAdmin)"
                        :activityId="submission.act_id"
                        :currentStepData="currentStepData"
                        :displaySignOffNotes="displaySignOffNotes"
                        :loadingSignOff="loadingSignOff"
                        :ppId="submission.id"
                        :submissionStatus="submissionStatus"
                        @emit-sign-off="saveSignOff"
                    ></priceworkflow-signoff-block>
                </section>
            </div>
            <div>&nbsp;</div>
            <priceworkflow-timeline
                :stepsData="stepsData"
                :submission="submission"
            ></priceworkflow-timeline>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            activity: "",
            brand: "",
            coo: "",
            currentStepData: {},
            custPrice: "",
            displaySignOffNotes: false,
            futureSignOffUsers: [],
            imgSource: "",
            isApprover: false,
            isErpAdmin: false,
            levelVar: "",
            listPrice: "",
            loading: true,
            loadingSignOff: false,
            orderNumbers: [],
            shortDesc: "",
            signOffNotes: "",
            signOffStatus: "",
            stepsData: [],
            submission: {},
            submissionStatus: "",
            uom: "",
            wfStepCurrent: "",
            wfStepUser: "",
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.stepsData = this.submission.steps_data;
            this.wfStepUser = this.submission.wf_step_user;
            this.wfStepCurrent = this.submission.wf_step_current;
            this.imgSource = this.submission.img_source;
            this.activity = this.submission.activity.activity;
            this.uom = this.submission.price_sku[0].price_uom;
            this.custPrice = this.submission.price_sku[0].price_cust;
            this.listPrice = this.submission.price_sku[0].price_list;
            this.brand = this.submission.prod.brand;
            this.shortDesc = this.submission.prod.short_desc;
            this.coo = this.submission.prod.coo;
            this.submissionStatus = this.submission.pp_status;
            this.futureSignOffUsers = this.submission.futureSignOffUserIds;

            this.listVar = ((this.custPrice - this.listPrice) / this.listPrice) * 100;
            this.listVar = this.listVar.toFixed(2);

            if(this.submission.ord_num != null) {
                let ordNums = this.submission.ord_num.split("|");
                this.orderNumbers = ordNums;
            }

            this.loading = false;
            this.loadingSignOff = false;

            this.getCurrentStepData();
        });
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            adminUsers: state => state.priceDeviationAdmins,
            priceERPAdmins: state => state.priceERPAdmins
        })
    },
    methods: {
        saveSignOff(emittedValues) {
            this.loadingSignOff = true;
            
            let data = {
                ppId: this.submission.id,
                notes: emittedValues.signOffNotes,
                status: emittedValues.signOffStatus,
                currentStep: this.wfStepCurrent,
                signOffUser: this.user.id,
                signOffFullName: this.user.full_name
            }

            axios.post(`/api/saveSignOff`, data).then(response => {
                $(".signOffNotes").val('');
                
                this.signOffNotes = null;
                this.signOffStatus = null;

                axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
                    this.submission = response.data;

                    this.stepsData = this.submission.steps_data;
                    this.wfStepUser = this.submission.wf_step_user;
                    this.wfStepCurrent = this.submission.wf_step_current;
                    this.submissionStatus = this.submission.pp_status;
                    this.futureSignOffUsers = this.submission.futureSignOffUserIds;

                    this.getCurrentStepData();

                    this.loadingSignOff = false;

                    this.displaySignOffNotes = false;
                });
            });
        },
        findIfApprover() {
            if(this.adminUsers.includes(this.user.id)) { // Admin
                this.isApprover = true;
            } else if (this.submission.currentSignOffId == this.user.id || this.futureSignOffUsers.includes(this.user.id.toString())) { // Next user in the workflow
                this.isApprover = true;
            } else { // Not allowed!
                this.isApprover = false;
            }
        },
        findIfErpAdmin() {
            if(this.priceERPAdmins.includes(this.user.id)) {
                this.isErpAdmin = true;
            } else {
                this.isErpAdmin = false;
            }
        },
        getCurrentStepData() {
            if(this.stepsData != null) {
                this.stepsData.forEach(element => {
                    if(element.isCurrent != null && element.isCurrent == 1) {
                        this.currentStepData = element;
                    }
                });
            }
        },
    },
    watch: {
        wfStepCurrent() {
            this.findIfApprover();
            this.findIfErpAdmin();
        }
    }
}
</script>
